import { Link } from "react-router-dom";
import { BUSINESS } from "../content";

export const Logo = ({ light = false }) => (
  <Link to="/" className="flex items-center gap-3" data-testid="brand-logo" aria-label="Pure Bliss Clean — home">
    <span className="leading-none">
      <span className={`block font-display text-lg font-extrabold tracking-tight ${light ? "text-white" : "text-brand-ink"}`}>
        Pure Bliss <span className="text-brand-teal">Clean</span>
      </span>
      <span className={`mt-0.5 block text-[11px] font-medium tracking-wide ${light ? "text-teal-100/80" : "text-slate-500"}`}>
        {BUSINESS.region}
      </span>
    </span>
  </Link>
);
